import React, { useState, useEffect } from 'react';
import { HTMLTable, Button, ProgressBar } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";

import "./Task.scss"

interface TaskMainProps {
    svc: AxiosInstance
}

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}

function TaskMain({ svc }: TaskMainProps) {
    const [taskList, setTaskList] = useState([] as TaskInfo[])

    useEffect(() => {
        //console.log("running task(s) found, refresh tasklist in 1s")
        const refreshTasks = async () => {
            try {
                console.log("calling tasklist")
                const res = await svc.post('/tasklist');
                setTaskList(res.data.data)
                //console.log("tasklist completed, call refreshTasks in 1s")
                //setTimeout(refreshTasks, 1000)
            } catch (error) {
                utils.showError(error)
            }
        }
        console.log("useEffect call refreeshTasks")
        refreshTasks()
        let timer = setInterval(refreshTasks, 1000)
        return () => {clearInterval(timer)}
    }, [svc])

    const onClearTasks = () => {
        (async () => {
            try {
                const res = await svc.post('/taskpurge');
                setTaskList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    return (
        <>
            <p>Tasks</p>
            <HTMLTable striped interactive condensed>
                <thead>
                    <tr>
                        <th className="TCol-Start">Start</th>
                        <th className="TCol-Task">Task</th>
                        <th className="TCol-Progress">Progress</th>
                        <th className="TCol-Message">Message</th>
                        <th className="TCol-End">End</th>
                        <th className="TCol-Log">Log</th>
                    </tr>
                </thead>
                <tbody>
                    {taskList.map((t, i) =>
                        <tr key={i}>
                            <td className="TCol-Start">{utils.formatTime(utils.hb_StoD(t.startTime))}</td>
                            <td className="TCol-Task">{t.description}</td>
                            <td className="TCol-Progress"><ProgressBar stripes={false} animate={false} value={t.progressValue / t.progressMax} /></td>
                            <td className="TCol-Message">{t.message}</td>
                            <td className="TCol-End">{t.endTime && utils.formatTime(utils.hb_StoD(t.endTime))}</td>
                            <td className="TCol-Log">{t.logFile && <a key={i} target="_blank" rel="noopener noreferrer" href={`${svc.defaults.baseURL}/logdownload?filename=${t.logFile}&inline`}>View</a>}</td>
                        </tr>
                    )}
                </tbody>
            </HTMLTable>
            <div className="Spacing-V-8"></div>
            <div className="Row">
                <Button className="Col-1-1" type="submit" icon={IconNames.CROSS} onClick={onClearTasks}>Clear</Button>
            </div>
            <div className="Spacing-V-16"></div>
        </>
    )
}

export default TaskMain